import { lazy } from "react";
import {
  Briefcase,
  Calendar,
  Home,
  Search,
  Users,
  User,
  type LucideIcon,
} from "lucide-react";

// Lazy so the public landing bundle doesn't have to download every
// post-auth page. Each named import resolves to a Promise<{default}>;
// React.lazy expects default exports, so we re-key the named export.
const DashboardPage = lazy(() =>
  import("@/pages/DashboardPage").then((m) => ({ default: m.DashboardPage })),
);
const NetworkPage = lazy(() =>
  import("@/pages/NetworkPage").then((m) => ({ default: m.NetworkPage })),
);
const PathwaysPage = lazy(() =>
  import("@/pages/PathwaysPage").then((m) => ({ default: m.PathwaysPage })),
);
const OpportunitiesPage = lazy(() =>
  import("@/pages/OpportunitiesPage").then((m) => ({ default: m.OpportunitiesPage })),
);
const ProfilePage = lazy(() =>
  import("@/pages/ProfilePage").then((m) => ({ default: m.ProfilePage })),
);
const EventsPage = lazy(() =>
  import("@/pages/EventsPage").then((m) => ({ default: m.EventsPage })),
);

export interface AppRouteDefinition {
  path: string;
  label: string;
  navLabel: string;
  icon: LucideIcon;
  element: JSX.Element;
  requiresAuth: boolean;
  showInNav?: boolean;
}

export const mainRoutes: AppRouteDefinition[] = [
  {
    path: "/dashboard",
    label: "Dashboard",
    navLabel: "Home",
    icon: Home,
    element: <DashboardPage />,
    requiresAuth: true,
  },
  {
    path: "/pathways",
    label: "Pathways",
    navLabel: "Pathways",
    icon: Search,
    element: <PathwaysPage />,
    requiresAuth: true,
  },
  {
    path: "/network",
    label: "Network",
    navLabel: "Network",
    icon: Users,
    element: <NetworkPage />,
    requiresAuth: true,
  },
  {
    path: "/opportunities",
    label: "Job Tracker",
    navLabel: "Jobs",
    icon: Briefcase,
    element: <OpportunitiesPage />,
    requiresAuth: true,
  },
  {
    path: "/events",
    label: "Events",
    navLabel: "Events",
    icon: Calendar,
    element: <EventsPage />,
    requiresAuth: true,
  },
  {
    path: "/profile",
    label: "Profile",
    navLabel: "Profile",
    icon: User,
    element: <ProfilePage />,
    requiresAuth: true,
    showInNav: false,
  },
  {
    path: "/settings",
    label: "Settings",
    navLabel: "Settings",
    icon: User,
    element: <ProfilePage />,
    requiresAuth: true,
    showInNav: false,
  },
];
